import { IAppUser } from '../interface/org'
import axios from 'axios'
import MiroTokenManager from './MiroTokenManager'

class BaseService {
  private orgApi = ''
  private keeperApi = ''
  private org: boolean
  private tokenManager = MiroTokenManager.getInstance()

  constructor(orgApi: boolean) {
    this.org = orgApi
    this.init()
  }

  protected init = () => {
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      const info: IAppUser = JSON.parse(userInfo)
      this.orgApi = info.domain
      this.keeperApi = this.keeperUrl(info)
    }
  }

  protected setKeeperUrl = (workspaceHost: string) => {
    this.keeperApi =
      import.meta.env.VITE_KEEPER_API ??
      `https://tablekeeper-${workspaceHost}/api/`
  }

  private keeperUrl = (info: IAppUser) => {
    const subdomain = info.host.split('.')[0]
    return `${info.keeperUrl}/miro/domain/${subdomain}`
  }

  private updateToken = async (): Promise<string> => {
    return this.tokenManager.getToken()
  }

  public get = async <T>(url: string, projectId?: number) => {
    const token = await this.updateToken()
    const { data } = await axios.get<T>(
      `${this.org ? this.orgApi : this.keeperApi}/${url}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Project-Id': projectId,
        },
      },
    )
    return data
  }

  public post = async (url: string, body: unknown, projectId?: number) => {
    const token = await this.updateToken()
    const { data } = await axios.post(
      `${this.org ? this.orgApi : this.keeperApi}/${url}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Project-Id': projectId,
        },
      },
    )
    return data
  }

  public put = async (url: string, body: unknown, projectId?: number) => {
    const token = await this.updateToken()
    const { data } = await axios.put(
      `${this.org ? this.orgApi : this.keeperApi}/${url}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Project-Id': projectId,
        },
      },
    )
    return data
  }

  public delete = async (url: string, projectId?: number) => {
    const token = await this.updateToken()
    const { data } = await axios.delete(
      `${this.org ? this.orgApi : this.keeperApi}/${url}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Project-Id': projectId,
        },
      },
    )
    return data
  }
}

export default BaseService
